import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { fetchVideos } from 'store/actions/video';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Chip,
  Paper,
  Toolbar,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';
import Paginator from 'utils/Paginator';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 20,
  },
}));

const VideoList = (props) => {
  const classes = useStyles();

  const [page, setPage] = useState(0);

  const [videos, total, search] = useSelector(state => [
    state.video.collection,
    state.video.total,
    state.video.search,
  ])

  const on = useDispatch();

  useEffect(() => {
    on(fetchVideos());
  }, [on]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    on(fetchVideos({ search, page: newPage + 1 }));
  };

  return (
    <Paper className={classes.root}>
      <Toolbar>
        <div className={classes.toolbar}>
          <Typography variant="h6">
            Vídeos
          </Typography>
          <Button
            variant="outlined"
            onClick={() => on(push('/videos/new'))}
            style={{ marginLeft: 10 }}
          >
            Adicionar
          </Button>
        </div>
      </Toolbar>
      <List component="nav">
        {videos.map(video => (
          <ListItem
            button
            onClick={() => on(push(`/videos/${video.id}`))}
            key={video.id}
          >
            <ListItemText
              primary={video.title}
              secondary={video.videoUrl}
            />
            <ListItemSecondaryAction>
              <Chip
                size="small"
                color="default"
                label={video.clientName}
                style={{ marginRight: 12 }}
              />
              <Chip
                size="small"
                color={video.isActive ? 'primary' : 'secondary'}
                label={video.isActive ? 'Ativo' : 'Inativo'}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Paginator
        page={page}
        total={total}
        handleChangePage={handleChangePage}
      />
    </Paper>
  );
};

export default VideoList;
